import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mayaStrategicImperativeListRoute } from 'basics/constants/routes.constants';
import { succesToast, warningToast } from 'basics/utils/toast';
import {
  SiFormCanceltCallbackType,
  SiFormSubmitCallbackType,
} from 'modules/maya/components/StrategicImperativeForm/StrategicImperativeForm.types';
import { useUpdateStrategicImperativeMutation } from 'modules/maya/graphql/mutations/updateStrategicImperatives';
import useGetStrategicImperativeByIdQuery from 'modules/maya/graphql/queries/getStrategicImperativeById';

const useStrategicImperativeEdit = () => {
  const navigate = useNavigate();

  const [updateStrategicImperative] = useUpdateStrategicImperativeMutation();

  const urlParams = useMemo(() => new URLSearchParams(window.location.search), []);

  const [loading, setLoading] = useState(true);

  const strategicImperative = useGetStrategicImperativeByIdQuery(urlParams.get('id')).data;

  useEffect(() => {
    if (strategicImperative) {
      setLoading(false);
    }
  }, [strategicImperative, setLoading]);

  const handleCancelStrategicImperativeForm: SiFormCanceltCallbackType = () => {
    navigate(mayaStrategicImperativeListRoute);
  };

  const handleSaveStrategicImperativeForm: SiFormSubmitCallbackType = async (si) => {
    const strategicImperativeData = await updateStrategicImperative(strategicImperative?._id || null, si);

    if (strategicImperativeData) {
      succesToast(`Strategic Imperative ${si.title} updated`);
      navigate(mayaStrategicImperativeListRoute);
    } else {
      warningToast(`Cannot update strategic imperative ${si.title}`);
    }
  };

  return {
    loading,
    strategicImperative,
    handleSaveStrategicImperativeForm,
    handleCancelStrategicImperativeForm,
  };
};

export default useStrategicImperativeEdit;
